import React from "react";
import { Card, Row, Col, Typography } from "antd";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";

const { Text, Title } = Typography;

const StyledCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: none;
  .ant-card-body {
    padding: 20px;
  }
`;

const IconWrapper = styled.div<{ bgColor: string; iconColor: string }>`
  background-color: ${(props) => props.bgColor};
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: ${(props) => props.iconColor};
  margin-right: 16px;
`;

const ScrollContainer = styled.div<{ isMobile: boolean }>`
  ${(props) =>
    props.isMobile &&
    `
    overflow-x: auto;
    padding-bottom: 8px;
    margin: 0 -12px;
    padding: 0 12px 8px 12px;
    
    &::-webkit-scrollbar {
      height: 0px;
      display: none !important;
    }
    &::-webkit-scrollbar-thumb {
      background: #d9d9d9;
      border-radius: 10px;
    }
  `}
`;

const StyledRow = styled(Row)<{ isMobile: boolean }>`
  ${(props) =>
    props.isMobile &&
    `
    flex-wrap: nowrap !important;
  `}
`;

const StyledCol = styled(Col)<{ isMobile: boolean }>`
  ${(props) =>
    props.isMobile &&
    `
    flex: 0 0 auto;
    width: 260px;
  `}
`;

const ValueWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

interface StatItem {
  label: string;
  value: string;
  total: string;
  icon: React.ReactNode;
  color: string; // This will now serve as iconColor
  bgColor: string;
}

interface StatsCardsProps {
  stats: StatItem[];
  screen?: any;
}

const StatsCards: React.FC<StatsCardsProps> = ({ stats }) => {
  const { screen } = useWindowSize();
  const isMobile = ["xs", "sm", "md"].includes(screen);

  return (
    <ScrollContainer isMobile={isMobile}>
      <StyledRow gutter={[16, 16]} isMobile={isMobile}>
        {stats.map((stat, index) => (
          <StyledCol xs={24} sm={12} lg={6} key={index} isMobile={isMobile}>
            <StyledCard>
              <div style={{ display: "flex", alignItems: "center" }}>
                <IconWrapper bgColor={stat.bgColor} iconColor={stat.color}>
                  {stat.icon}
                </IconWrapper>
                <ValueWrapper>
                  <Text
                    type="secondary"
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      fontWeight: 600,
                    }}
                  >
                    {stat.label}
                  </Text>
                  <Title level={4} style={{ margin: 0 }}>
                    {stat.value} / {stat.total}
                  </Title>
                </ValueWrapper>
              </div>
            </StyledCard>
          </StyledCol>
        ))}
      </StyledRow>
    </ScrollContainer>
  );
};

export default StatsCards;
